import React from 'react';
import loadable from '@loadable/component';
import { clearResults } from 'store/search/searchActions';

export const AsyncListSearchLayout = loadable(() => import(/* webpackPrefetch: true */ './ListSearchLayout'));

const ListSearch = (props) => {
  return <AsyncListSearchLayout {...props} />;
};

ListSearch.activeSplits = ['blue_banner_message'];

ListSearch.onExitPage = ({ store }) => {
  store.dispatch(clearResults());
};

export default ListSearch;
